import { autoinject, bindable } from 'aurelia-framework';
import {NotificationModel } from "./notification-model";
import {NotificationService, NotificationType } from "./notification-service";

interface IFromDomNotification {
	title: string;
	content: string;
	type: string;
}

@autoinject
export class NotificationsContainer {
	@bindable onInitNotifications: string;

	get notifications(): NotificationModel[] {
		return this.notificationService.notifications;
	}

	domNotificationType(type: string): NotificationType {
		switch (type) {
			case "success":
				return NotificationType.Success;
			case "error":
				return NotificationType.Error;
			case "warning":
				return NotificationType.Warning;
			case "info":
				return NotificationType.Info;
			default:
				return null;
		}
	}

	constructor(private notificationService: NotificationService) {
	}

	attached() {
		if (this.onInitNotifications) {
			const deserialized = JSON.parse(this.onInitNotifications);
			deserialized.forEach((o: IFromDomNotification) =>
				this.notificationService.push(o.title, o.content, this.domNotificationType(o.type)));
		}
	}
}
